// Which fields.js rule governs one column on one contact table.
//
// Phone1 and Phone2 are the same column name on Customers, Sellers and Brokers,
// but NOT the same rule: a Ugandan dealer's customers are Ugandan while its
// sellers routinely are not — stock routes through Mombasa and Dar es Salaam,
// and the live data holds a Kenyan seller and a Tanzanian one. So Sellers
// resolve to the wider Phone1_Seller / Phone2_Seller entries.
//
// MIRRORS contactRuleKey in node/helpers/contactRules.js. The two must agree, or
// the browser and the server disagree about the same edit — pinned by
// validation/ugPhone.test.js and node/tests/p68-contact-rules.mjs.

import fields from '../fields';

const SELLER_PHONE = { Phone1: 'Phone1_Seller', Phone2: 'Phone2_Seller' };

/**
 * @param {string} table      'Customers' | 'Sellers' | 'Brokers' | …
 * @param {string} fieldName  the column name the form field carries
 * @returns the fields.js entry to validate against, or undefined
 */
export function contactFieldFor(table, fieldName) {
  const key = (table === 'Sellers' && SELLER_PHONE[fieldName]) || fieldName;
  return fields[key];
}

export default contactFieldFor;
